import LOCAL_STORAGE from 'utils/localStorage/Constants';
import Storage from 'utils/localStorage/Storage';
import store from 'store/Store';
import orderUtils from 'utils/Order';
import Empty from 'constants/empty';

function iSplitEDDExperienceDisplayed() {
    const splitEDDExperience = Storage.local.getItem(LOCAL_STORAGE.SPLIT_EDD_EXPERIENCE) || false;

    return splitEDDExperience;
}

function hasMultipleDeliveryGroups() {
    const orderDetails = store.getState().order.orderDetails;
    const shippingMethods = orderUtils.getHardGoodShippingGroup(orderDetails)?.shippingMethod
        ? [orderUtils.getHardGoodShippingGroup(orderDetails).shippingMethod]
        : Empty.Array;

    const totalDeliveryGroups = shippingMethods.reduce((total, method) => total + (method?.deliveryGroups?.length || 0), 0);

    return totalDeliveryGroups > 1;
}

export default { iSplitEDDExperienceDisplayed, hasMultipleDeliveryGroups };
